import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./DragonMilkBackground.css";

gsap.registerPlugin(ScrollTrigger);

const BUBBLE_COUNT = 18;

function DragonMilkBackground() {
  const containerRef = useRef(null);
  const bubblesRef = useRef([]);
  const cloudsRef = useRef([]);
  const dragonRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Floating bubbles – continuous float + slight scale
    bubblesRef.current.forEach((el, i) => {
      if (!el) return;
      gsap.set(el, { opacity: 0.15 + Math.random() * 0.25, scale: 0.4 + Math.random() * 0.8 });
      gsap.to(el, {
        y: -80 - Math.random() * 120,
        x: `+=${(Math.random() - 0.5) * 60}`,
        duration: 4 + Math.random() * 4,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: i * 0.2,
      });
      gsap.to(el, {
        scale: "+=0.2",
        duration: 2 + Math.random() * 2,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: i * 0.15,
      });
    });

    // Soft clouds drift
    cloudsRef.current.forEach((el, i) => {
      if (!el) return;
      const dir = i % 2 === 0 ? 1 : -1;
      gsap.to(el, {
        x: 100 * dir,
        duration: 25 + i * 5,
        repeat: -1,
        yoyo: true,
        ease: "none",
      });
    });

    // Dragon silhouette subtle parallax on scroll
    const dragon = dragonRef.current;
    if (dragon) {
      ScrollTrigger.create({
        trigger: container,
        start: "top top",
        end: "bottom bottom",
        onUpdate: (self) => {
          gsap.set(dragon, { y: self.progress * 40, rotation: self.progress * 2 });
        },
      });
    }

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  return (
    <div ref={containerRef} className="dragon-milk-bg" aria-hidden="true">
      <div className="dragon-milk-bg__gradient" />
      <div ref={dragonRef} className="dragon-milk-bg__dragon" />
      <div className="dragon-milk-bg__clouds">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            ref={(el) => (cloudsRef.current[i - 1] = el)}
            className="dragon-milk-bg__cloud"
            style={{ left: `${15 + (i - 1) * 35}%`, top: `${10 + (i - 1) * 25}%` }}
          />
        ))}
      </div>
      <div className="dragon-milk-bg__bubbles">
        {Array.from({ length: BUBBLE_COUNT }).map((_, i) => (
          <div
            key={i}
            ref={(el) => (bubblesRef.current[i] = el)}
            className="dragon-milk-bg__bubble"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${70 + Math.random() * 30}%`,
              width: 8 + Math.random() * 24,
              height: 8 + Math.random() * 24,
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default DragonMilkBackground;
